export var LOCAL_STORAGE_APPLE_PAY_AVAILABLE = 'applePayAvailable';